import type { AuthProvider } from "@refinedev/core";
import { supabase } from "@/lib/supabase";
import { setSentryUserContext } from "@/lib/sentry";

export const authProvider: AuthProvider = {
  async login({ email, password }) {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) return { success: false, error: { name: "LoginError", message: error.message } };

    // Cargar perfil para Sentry
    const { data: perfil } = await supabase
      .from("perfiles")
      .select("id, rol, tienda_id")
      .eq("id", data.user.id)
      .single();

    setSentryUserContext({
      id: data.user.id,
      email: data.user.email ?? undefined,
      rol: perfil?.rol,
      tienda_id: perfil?.tienda_id ?? undefined,
    });

    return { success: true, redirectTo: "/" };
  },

  async logout() {
    await supabase.auth.signOut();
    setSentryUserContext(null);
    return { success: true, redirectTo: "/login" };
  },

  async check() {
    const { data } = await supabase.auth.getSession();
    if (!data.session) return { authenticated: false, redirectTo: "/login" };
    return { authenticated: true };
  },

  async getIdentity() {
    const { data } = await supabase.auth.getUser();
    if (!data.user) return null;

    const { data: perfil } = await supabase
      .from("perfiles")
      .select("*, tiendas(nombre, marca, tipo_producto)")
      .eq("id", data.user.id)
      .single();

    return {
      id: data.user.id,
      email: data.user.email,
      name: perfil?.nombre_completo,
      rol: perfil?.rol,
      tienda: perfil?.tiendas,
      onboarding_completado: perfil?.onboarding_completado ?? false,
    };
  },

  async forgotPassword({ email }) {
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/auth/recovery`,
    });
    if (error) return { success: false, error: { name: "ResetError", message: error.message } };
    return { success: true };
  },

  async onError(error) {
    // eslint-disable-next-line no-console
    console.error("Auth error:", error);
    if (error?.status === 401) return { logout: true, redirectTo: "/login" };
    return {};
  },
};
